import {atom} from "nanostores";
import {UserCredential} from "../types/UserCredential";


export const UserCredentialStore = atom<UserCredential>(undefined as any)